<button mat-button ixTest="apps-settings" [matMenuTriggerFor]="menu">
  {{ 'Settings' | translate }}
  <ix-icon name="mdi-menu-down" class="menu-caret"></ix-icon>
</button>

<mat-menu #menu="matMenu" overlapTrigger="false">
  <button
    *ixRequiresRoles="requiredRoles"
    mat-menu-item
    ixTest="choose-pool"
    (click)="onChoosePool()"
  >
    {{ 'Choose Pool' | translate }}
  </button>
  <button *ixRequiresRoles="requiredRoles" mat-menu-item ixTest="advanced-settings" (click)="onAdvancedSettings()">
    {{ 'Advanced Settings' | translate }}
  </button>
  <ng-container *ngIf="!!(kubernetesStore.selectedPool$ | async)">
    <button
      *ixRequiresRoles="requiredRoles"
      mat-menu-item
      ixTest="unset-pool"
      (click)="onUnsetPool()"
    >
      {{ 'Unset Pool' | translate }}
    </button>
  </ng-container>
  <button mat-menu-item ixTest="container-images" [routerLink]="['/apps', 'installed', 'manage-container-images']">
    {{ 'Manage Container Images' | translate }}
  </button>
</mat-menu>
